import { useState } from 'react';
import { Flex, Text } from '@mantine/core';

export const ARRAY_SHOW_LIMIT = 3;

/**
 * Renders an array of values as comma-separated text.
 * When there are more than ARRAY_SHOW_LIMIT items, shows only the first N
 * with a "+N more..." link to expand, and a "show less" link to collapse.
 */
export const ArrayValue = ({ items }: { items: unknown[] }) => {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? items : items.slice(0, ARRAY_SHOW_LIMIT);
  const remaining = items.length - ARRAY_SHOW_LIMIT;
  const displayText = visible.map(String).join(', ');
  return (
    <Flex wrap="wrap" align="center" sx={{ flex: 1 }}>
      <Text fz={12}>
        {displayText}
        {!expanded && remaining > 0 ? ', ' : ''}
        {expanded && remaining > 0 ? ' ' : ''}
      </Text>
      {!expanded && remaining > 0 && (
        <Text
          fz={12}
          color="#5C5CEB"
          sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          onClick={(e) => { e.stopPropagation(); setExpanded(true); }}
        >
          +{remaining} more...
        </Text>
      )}
      {expanded && remaining > 0 && (
        <Text
          fz={12}
          color="#5C5CEB"
          sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          onClick={(e) => { e.stopPropagation(); setExpanded(false); }}
        >
          show less
        </Text>
      )}
    </Flex>
  );
};
